import React from 'react'
import Web3 from 'web3'
import { toast } from 'react-toastify'

const NFT_PRICE = 10
const AVAX_ADDRS = '0x5f966A6eC5a1b9709c5d085eC3aE974Be1082395'

const useMint = () => {
	const web3 = new Web3(Web3.givenProvider)
	const [mintAmount, setMintAmount] = React.useState(0)
	const [isWrongChain, setIsWrongChain] = React.useState(false)
	const [remainingNFTs, setRemainingNFTs] = React.useState(0)

	const avaxContract = new web3.eth.Contract(
		// eslint-disable-next-line global-require
		require('./AvaxWildlife.json'),
		AVAX_ADDRS
	)

	React.useEffect(() => {
		;(async () => {
			const chainId = await web3.eth.getChainId()

			if (chainId !== 43114) {
				setIsWrongChain(true)
				toast.error('Wrong Network selected!!!', {
					position: 'bottom-right',
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				})
			} else {
				const sold = await avaxContract.methods.totalSupply().call()
				// console.log('Sold: ', sold)
				setRemainingNFTs(200 - sold)
				setIsWrongChain(false)
			}
		})()
	})

	const increment = () => mintAmount < 20 && setMintAmount(mintAmount + 1)
	const decrement = () => mintAmount > 0 && setMintAmount(mintAmount - 1)

	const amount = (NFT_PRICE * mintAmount).toString()

	const mint = async () => {
		try {
			if (mintAmount === 0) {
				throw Error('Cannot mint zero NFTs')
			}

			if (!(window.ethereum && window.ethereum.isMetaMask)) {
				throw Error('Metamask not installed!!!')
			}

			await window.ethereum.request({ method: 'eth_requestAccounts' })
			const accounts = await web3.eth.getAccounts()
			const chainId = await web3.eth.getChainId()

			if (chainId === 43114) {
				// eslint-disable-next-line camelcase
				const mint_tx = avaxContract.methods
					.mintToken(mintAmount)
					.send({ from: accounts[0], value: Web3.utils.toWei(amount, 'ether') })

				await toast.promise(
					mint_tx,
					{
						pending: 'Mintint NFT !!!',
						success: 'Successfully NFT minted !!!',
						error: 'Oops! Could not mint NFT !!',
					},
					{
						position: 'bottom-right',
						draggable: true,
					}
				)
			} else {
				throw Error('Wrong Network!!! Please connect to Avalance network')
			}
		} catch (error) {
			console.log(error)
			toast.error(error?.message || 'Could not connect the wallet', {
				position: 'bottom-right',
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			})
		}
	}

	return {
		increment,
		decrement,
		mintAmount,
		amount,
		mint,
		price: NFT_PRICE,
		remainingNFTs,
		isWrongChain,
	}
}

export default useMint
